import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { IhmPipesModule } from '../../shared/pipes/ihm-pipes.module';
import { IhmSystemStatusComponent } from './ihm-system-status.component';

@NgModule({
  imports: [CommonModule, MatCardModule, MatIconModule, IhmPipesModule],
  declarations: [IhmSystemStatusComponent],
  exports: [IhmSystemStatusComponent]
})
export class IhmSystemStatusModule {}
